export default {
  integer (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[0-9]+$').test(value) && !new RegExp('^\\-[0-9]+$').test(value)) {
        callback(new Error('请输入整数'))
      }
    }
    callback()
  },
  positiveInteger (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[0-9]+$').test(value)) {
        callback(new Error('请输入正整数'))
      }
    }
    callback()
  },
  positiveNumber (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[0-9.]+$').test(value)) {
        callback(new Error('请输入正数'))
      }
    }
    callback()
  },
  positiveMoney (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[0-9]+(.[0-9]{1,2})?$').test(value)) {
        callback(new Error('请输入正确金额'))
      }
    }
    callback()
  }
}
